/** @format */

import Row from "react-bootstrap/Row";
import { useNavigate } from "react-router-dom";
import * as formik from "formik";
import * as yup from "yup";

import { signInSuccess } from "../../../../store";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../store/hook";
import * as RoleSelector from "src/store/role/selector.ts";
import { useState } from "react";
import { useUserSignIn } from "../../../../api/mutations/auth.mutation";
import { Container } from "react-bootstrap";
import EmpSettingForm from "./settings-form";
import background from "src/assets/images/9926.jpg";

function EmpSetting() {
  return (
    <>
      <div
        id="content-page"
        className="content-inner"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Container className="py-5 ">
          <Row className="justify-content-center">
            <div className="bg-white rounded shadow-sm p-4">
              <EmpSettingForm />
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default EmpSetting;
